import { api } from '../../utils/api';
import { type OrderRootResponse, type IOrder } from '../../types/IOrder';
import { type AxiosResponse } from 'axios';

// Получаем 1 заказ по его ID
export const getOrderById = async (
  uuid: string,
  signal?: AbortSignal
): Promise<IOrder> => {
  const response: AxiosResponse<OrderRootResponse, unknown> = await api.get(
    '/admin/order/' + uuid,
    { signal }
  );
  return response.data.response;
};
